import Model from "../Model";

class RepresentantsviewsZone extends Model{

    buildUrl ({ param }) {
        return ['visitsbyemployee/getbyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantsviewsZone;